import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import Button from '../../../UI/Button/Button';
import Translation from '../../../v2/lang/Translation';
import isUsingArtemisStyles from '../../../v2/selectors/isUsingArtemisStyles';
import MediaQueries from '../../../v2/style-helper/MediaQueries';
import Spacing from '../../../v2/style-helper/Spacing';
import Typography from '../../../v2/style-helper/Typography';
import MoreTreesPrimaryIcon from './images/MoreTreesPrimaryIcon';

const useStyles = createUseStyles({
  moreTrees: {
    textAlign: 'center',
    borderTop: 'solid 1px #ccc',
    fontFamily: 'Avenir, Helvetica, sans-serif',
  
    [MediaQueries.tablet]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      textAlign: 'left',
    },
    
    '& #MoreTrees__button': {
      background: '#153135',
      color: '#fff',
    },
    
    '& svg': {
      maxHeight: 70,
      marginTop: 10,
    },
  },
  strapline: {
    textTransform: 'uppercase',
    fontSize: '1em',
    fontWeight: 500,
    letterSpacing: 3,
    paddingTop: Spacing.single,
  },
  description: {
    paddingTop: Spacing.double,
    fontSize: props => ((props.isUsingArtemisStyles && props.theme.typography?.[Typography.body])
      ? props.theme.typography[Typography.body].largeDevice.fontSize : 16),
    fontWeight: 400,
    lineHeight: '21px',
    marginBottom: Spacing.double,
  },
});

export function MoreTrees(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <div className={classes.moreTrees} data-test="MoreTrees">
      <MoreTreesPrimaryIcon />
      <h4 className={classes.strapline}>
        <Translation>checkout.complete.moreTrees.strapline</Translation>
      </h4>
      <p className={classes.description} data-test="MoreTrees__description">
        <Translation>checkout.complete.moreTrees.description</Translation>
      </p>
      <Button
        id="MoreTrees__button"
        primary
        href={props.url}
      >
        <Translation>checkout.complete.moreTrees.buttonText</Translation>
      </Button>
    </div>
  );
}

const mapStateToProps = state => ({
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

MoreTrees.propTypes = {
  url: PropTypes.string.isRequired,
  isUsingArtemisStyles: PropTypes.bool,
};

export default connect(mapStateToProps)(MoreTrees);
